import React from 'react'
import styled from 'styled-components'
import { storyblokEditable, SbBlokData } from '@storyblok/react'
import { SbAsset } from '../../types'

interface HeroModuleImageProps {
    blok: {
        image?: SbAsset
        heading?: string
        imageHeight?: string
        imageWidth?: string
        imageBorderRadius?: string
    }
}

const Container = styled.div`
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    border-radius: 8px;
`

const Image = styled.img<{ $imageHeight?: string; $imageWidth?: string; $imageBorderRadius?: string }>`
  height: ${props => props.$imageHeight || 'auto'};
  width: ${props => props.$imageWidth || 'auto'};
  border-radius: ${props => props.$imageBorderRadius || '0'};
`

const HeroModuleImage = ({ blok }: HeroModuleImageProps & { blok: SbBlokData }) => {
    console.log(blok, 'blok')
    return (
        <Container {...storyblokEditable(blok)}>
            <Image src={blok.image?.filename} alt={blok.image?.alt || blok.heading} $imageHeight={blok.imageHeight} $imageWidth={blok.imageWidth} $imageBorderRadius={blok.imageBorderRadius} />
        </Container>
    )
}

export default HeroModuleImage